var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useSyncExternalStore } from 'react';
import { getHighlighter, createCssVariablesTheme } from 'shiki';
export const languages = [
    'bash',
    'c',
    'c#',
    'c++',
    'clojure',
    'console',
    'cpp',
    'cs',
    'csharp',
    'css',
    'csv',
    'diff',
    'docker',
    'dockerfile',
    'go',
    'gql',
    'graphql',
    'html',
    'http',
    'java',
    'javascript',
    'js',
    'json',
    'jsx',
    'kotlin',
    'markdown',
    'md',
    'mdx',
    'mermaid',
    'objc',
    'objective-c',
    'perl',
    'perl6',
    'php',
    'proto',
    'py',
    'python',
    'rb',
    'ruby',
    'rust',
    'scala',
    'sh',
    'shell',
    'sql',
    'swift',
    'terraform',
    'ts',
    'typescript',
    'xml',
    'yaml',
    'yml',
    'zsh'
];
// Create a custom CSS variables theme, the following are the default values
const cssVariablesTheme = createCssVariablesTheme({
    name: 'css-variables',
    variablePrefix: '--shiki-',
    variableDefaults: {},
    fontStyle: true
});
const cssVariablesDarkTheme = createCssVariablesTheme({
    name: 'css-variables-dark',
    variablePrefix: '--shiki-dark-',
    variableDefaults: {},
    fontStyle: true
});
let sharedHighlighter;
let sharedHighlighterListeners = new Set();
function loadHighlighter() {
    return __awaiter(this, void 0, void 0, function* () {
        sharedHighlighter = yield getHighlighter({
            themes: [cssVariablesTheme, cssVariablesDarkTheme],
            langs: languages
        });
        sharedHighlighterListeners.forEach((listener) => listener());
    });
}
export function useHighlighter() {
    const highlighter = useSyncExternalStore((onStoreChange) => {
        sharedHighlighterListeners.add(onStoreChange);
        return () => sharedHighlighterListeners.delete(onStoreChange);
    }, () => {
        return sharedHighlighter;
    }, () => undefined);
    useEffect(() => {
        if (!highlighter) {
            loadHighlighter();
        }
    }, [highlighter]);
    return highlighter;
}
